<script>
    import { classNames } from "../../utils";
    import { Speaker, Close } from "../../index";
    let cls = "sui-notice-bar";
    /*
        'default' | 'alert' | 'error' | 'info'
    */
    export let closeable = false;
    export let color = "default";
    let show = true;
    const xi = 0.02;
    let time = 8;
    let pos = 0;
    let w = 0;
    let outW = 50;

    $: {
        if (w > outW) {
            setTimeout(() => {
                pos = w * -1;
                time = w * xi;
            }, 1000);
        }
    }

    function handleEnd() {
        pos = outW;
        time = 0;
        setTimeout(() => {
            pos = w * -1;
            time = (w + outW) * xi;
        }, 300);
    }

    function close() {
        alert(8888)
        show = false
    }
</script>

{#if show}
    <div
        class={classNames({
            [cls]: cls,
            [`${cls}-${color}`]: color,
        })}
    >
        <div class={`${cls}-icon`}>
            <slot name="icon">
                <Speaker color="var(--notice-text-color)" size={18} />
            </slot>
        </div>
        <div class={`${cls}-content`}>
            <div
                class={`${cls}-content-inner`}
                class:animate={w > outW}
                bind:offsetWidth={outW}
                on:transitionend={handleEnd}
                style:transition-duration={`${time}s`}
                style:transform={`translate3d(${pos}px,0,0)`}
            >
                <span bind:offsetWidth={w}><slot /></span>
            </div>
        </div>
        <div class={`${cls}-extra`} >
            <slot name="extra">
                {#if closeable}
                    <Close
                        color="var(--notice-text-color)"
                        on:click={()=>show = false}
                        size={18}
                    />
                {/if}
            </slot>
        </div>
    </div>
{/if}

<style lang="less">
    @import "./noticeBar.less";
</style>
